/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type {
  AccountingTypeResponse,
  IdResponse,
  KanResponse,
  KoResponse,
  MasterAccountingTypeListResponse,
  MasterFlatListResponse,
  MasterKanListResponse,
  MasterKoListResponse,
  MasterMokuListResponse,
  MastersOptionsResponse,
  MokuResponse,
  SuccessResponse,
} from './model';
import { MasterFlatListItemLevel } from './model';

export const getGetMastersOptionsResponseMock = (): MastersOptionsResponse => ({
  accounting_types: [
    { id: '297bf4f4-137c-434c-8148-21be11d4e609', code: '01', name: '一般会計', year: 2025 },
  ],
  kans: [
    {
      id: '00000008-0000-0000-0000-000000000008',
      accounting_type_id: '297bf4f4-137c-434c-8148-21be11d4e609',
      code: '08',
      name: '土木費',
    },
  ],
  kos: [
    {
      id: '00080200-0000-0000-0000-000000080200',
      kan_id: '00000008-0000-0000-0000-000000000008',
      code: '02',
      name: '道路橋りょう費',
    },
  ],
  mokus: [
    {
      id: '00080201-0000-0000-0000-000008020001',
      ko_id: '00080200-0000-0000-0000-000000080200',
      code: '01',
      name: '道路新設改良費',
    },
  ],
});

export const getListAccountingTypesResponseMock = (): MasterAccountingTypeListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        code: faker.string.alpha({ length: { min: 10, max: 50 } }),
        name: faker.string.alpha({ length: { min: 10, max: 255 } }),
        year: faker.number.int({ min: 1900, max: 2100 }),
        kans: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
          () => ({
            id: faker.string.uuid(),
            code: faker.string.alpha({ length: { min: 10, max: 50 } }),
            name: faker.string.alpha({ length: { min: 10, max: 255 } }),
            kos: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
              () => ({
                id: faker.string.uuid(),
                code: faker.string.alpha({ length: { min: 10, max: 50 } }),
                name: faker.string.alpha({ length: { min: 10, max: 255 } }),
                mokus: Array.from(
                  { length: faker.number.int({ min: 1, max: 10 }) },
                  (_, i) => i + 1,
                ).map(() => ({
                  id: faker.string.uuid(),
                  code: faker.string.alpha({ length: { min: 10, max: 50 } }),
                  name: faker.string.alpha({ length: { min: 10, max: 255 } }),
                })),
              }),
            ),
          }),
        ),
      }),
    ),
  },
});

export const getCreateAccountingTypeResponseMock = (): IdResponse => ({
  id: '00000003-0000-0000-0000-000000000003',
});

export const getGetAccountingTypeResponseMock = (
  overrideResponse: Partial<AccountingTypeResponse> = {},
): AccountingTypeResponse => ({
  id: faker.string.uuid(),
  code: faker.string.alpha({ length: { min: 10, max: 50 } }),
  name: faker.string.alpha({ length: { min: 10, max: 255 } }),
  year: faker.number.int({ min: 1900, max: 2100 }),
  ...overrideResponse,
});

export const getUpdateAccountingTypeResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteAccountingTypeResponseMock = (): SuccessResponse => ({ success: true });

export const getListKansResponseMock = (): MasterKanListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        accounting_type_id: faker.string.uuid(),
        code: faker.string.alpha({ length: { min: 10, max: 50 } }),
        name: faker.string.alpha({ length: { min: 10, max: 255 } }),
      }),
    ),
  },
});

export const getCreateKanResponseMock = (): IdResponse => ({
  id: '00000011-0000-0000-0000-000000000011',
});

export const getGetKanResponseMock = (
  overrideResponse: Partial<KanResponse> = {},
): KanResponse => ({
  id: faker.string.uuid(),
  accounting_type_id: faker.string.uuid(),
  code: faker.string.alpha({ length: { min: 10, max: 50 } }),
  name: faker.string.alpha({ length: { min: 10, max: 255 } }),
  ...overrideResponse,
});

export const getUpdateKanResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteKanResponseMock = (): SuccessResponse => ({ success: true });

export const getListKosResponseMock = (): MasterKoListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        kan_id: faker.string.uuid(),
        code: faker.string.alpha({ length: { min: 10, max: 50 } }),
        name: faker.string.alpha({ length: { min: 10, max: 255 } }),
      }),
    ),
  },
});

export const getCreateKoResponseMock = (): IdResponse => ({
  id: '00080500-0000-0000-0000-000000080500',
});

export const getGetKoResponseMock = (overrideResponse: Partial<KoResponse> = {}): KoResponse => ({
  id: faker.string.uuid(),
  kan_id: faker.string.uuid(),
  code: faker.string.alpha({ length: { min: 10, max: 50 } }),
  name: faker.string.alpha({ length: { min: 10, max: 255 } }),
  ...overrideResponse,
});

export const getUpdateKoResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteKoResponseMock = (): SuccessResponse => ({ success: true });

export const getListMokusResponseMock = (): MasterMokuListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        ko_id: faker.string.uuid(),
        code: faker.string.alpha({ length: { min: 10, max: 50 } }),
        name: faker.string.alpha({ length: { min: 10, max: 255 } }),
      }),
    ),
  },
});

export const getCreateMokuResponseMock = (): IdResponse => ({
  id: '00080205-0000-0000-0000-000008020005',
});

export const getGetMokuResponseMock = (
  overrideResponse: Partial<MokuResponse> = {},
): MokuResponse => ({
  id: faker.string.uuid(),
  ko_id: faker.string.uuid(),
  code: faker.string.alpha({ length: { min: 10, max: 50 } }),
  name: faker.string.alpha({ length: { min: 10, max: 255 } }),
  ...overrideResponse,
});

export const getUpdateMokuResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteMokuResponseMock = (): SuccessResponse => ({ success: true });

export const getListMastersFlatResponseMock = (): MasterFlatListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        year: faker.number.int({ min: undefined, max: undefined }),
        level: faker.helpers.arrayElement(Object.values(MasterFlatListItemLevel)),
        code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        accounting_type_id: faker.string.uuid(),
        accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
        accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        kan_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
        kan_code: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        kan_name: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        ko_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
        ko_code: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        ko_name: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        moku_id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
        moku_code: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        moku_name: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
      }),
    ),
  },
});

export const getGetMastersOptionsMockHandler = (
  overrideResponse?:
    | MastersOptionsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MastersOptionsResponse> | MastersOptionsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/options',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetMastersOptionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListAccountingTypesMockHandler = (
  overrideResponse?:
    | MasterAccountingTypeListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MasterAccountingTypeListResponse> | MasterAccountingTypeListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/accounting-types',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListAccountingTypesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAccountingTypeMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/masters/accounting-types',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAccountingTypeResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetAccountingTypeMockHandler = (
  overrideResponse?:
    | AccountingTypeResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountingTypeResponse> | AccountingTypeResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/accounting-types/:accountingTypeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAccountingTypeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateAccountingTypeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/masters/accounting-types/:accountingTypeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateAccountingTypeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteAccountingTypeMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/masters/accounting-types/:accountingTypeId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteAccountingTypeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListKansMockHandler = (
  overrideResponse?:
    | MasterKanListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MasterKanListResponse> | MasterKanListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/kans',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListKansResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateKanMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/masters/kans',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateKanResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetKanMockHandler = (
  overrideResponse?:
    | KanResponse
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<KanResponse> | KanResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/kans/:kanId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetKanResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateKanMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/masters/kans/:kanId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateKanResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteKanMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/masters/kans/:kanId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteKanResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListKosMockHandler = (
  overrideResponse?:
    | MasterKoListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MasterKoListResponse> | MasterKoListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/kos',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListKosResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateKoMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/masters/kos',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateKoResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetKoMockHandler = (
  overrideResponse?:
    | KoResponse
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<KoResponse> | KoResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/kos/:koId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetKoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateKoMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/masters/kos/:koId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateKoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteKoMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/masters/kos/:koId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteKoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListMokusMockHandler = (
  overrideResponse?:
    | MasterMokuListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MasterMokuListResponse> | MasterMokuListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/mokus',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListMokusResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateMokuMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/masters/mokus',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateMokuResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetMokuMockHandler = (
  overrideResponse?:
    | MokuResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MokuResponse> | MokuResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/mokus/:mokuId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetMokuResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateMokuMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/masters/mokus/:mokuId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateMokuResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteMokuMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/masters/mokus/:mokuId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteMokuResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getListMastersFlatMockHandler = (
  overrideResponse?:
    | MasterFlatListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MasterFlatListResponse> | MasterFlatListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/masters/flat',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListMastersFlatResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetMastersOptionsMockHandler(),
  getListAccountingTypesMockHandler(),
  getCreateAccountingTypeMockHandler(),
  getGetAccountingTypeMockHandler(),
  getUpdateAccountingTypeMockHandler(),
  getDeleteAccountingTypeMockHandler(),
  getListKansMockHandler(),
  getCreateKanMockHandler(),
  getGetKanMockHandler(),
  getUpdateKanMockHandler(),
  getDeleteKanMockHandler(),
  getListKosMockHandler(),
  getCreateKoMockHandler(),
  getGetKoMockHandler(),
  getUpdateKoMockHandler(),
  getDeleteKoMockHandler(),
  getListMokusMockHandler(),
  getCreateMokuMockHandler(),
  getGetMokuMockHandler(),
  getUpdateMokuMockHandler(),
  getDeleteMokuMockHandler(),
  getListMastersFlatMockHandler(),
];
